// src/components/Avatar.jsx
import React, { useEffect, useMemo, useState } from "react";
import { getDiceBearAvatar, getUserAvatar } from "../utils/avatar";

export default function Avatar({
  user,
  src,
  userUUID,
  alt = "avatar",
  className = "",
}) {
  const fallback = useMemo(
    () => getDiceBearAvatar(userUUID || user?.user_uuid || user?.id || "default"),
    [userUUID, user?.user_uuid, user?.id]
  );
  const initialSrc = useMemo(
    () => (user ? getUserAvatar(user) : src && src.trim() !== "" ? src : fallback),
    [fallback, src, user]
  );

  const [imgSrc, setImgSrc] = useState(initialSrc);

  useEffect(() => {
    setImgSrc(initialSrc);
  }, [initialSrc]);

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={`rounded-full object-cover ${className}`}
      onError={() => {
        if (imgSrc !== fallback) setImgSrc(fallback);
      }}
    />
  );
}